import React from 'react';
import { Button } from 'reactstrap';

// Floating action bar pinned to the bottom-right of the detail page. Which
// buttons appear is driven by the orchestrator:
//   - Back              : every tab except the first
//   - Save as Draft     : editable tabs (Requirement / Supporting Doc / DMUT)
//   - Save & Completed  : editable tabs — validates then marks the step done
//   - Submit            : Overview tab, only when all steps are Completed
// In read-only (detail) mode only Back is shown.
const FloatingActions = ({
  showBack,
  showSaveDraft,
  showSaveCompleted,
  showSubmit,
  onBack,
  onSaveDraft,
  onSaveCompleted,
  onSubmit,
}) => {
  if (!showBack && !showSaveDraft && !showSaveCompleted && !showSubmit) {
    return null;
  }

  return (
    <div
      className='d-flex gap-2 justify-content-end'
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 5,
        padding: '12px 4px',
        marginTop: '1rem',
        background:
          'linear-gradient(to top, rgba(255,255,255,0.95) 60%, rgba(255,255,255,0))',
      }}
    >
      {showBack && (
        <Button color='light' className='btn-label' onClick={onBack}>
          <i className='ri-arrow-left-line label-icon align-middle'></i>
          Back
        </Button>
      )}
      {showSaveDraft && (
        <Button
          color='secondary'
          outline
          className='btn-label'
          onClick={onSaveDraft}
        >
          <i className='ri-draft-line label-icon align-middle'></i>
          Save as Draft
        </Button>
      )}
      {showSaveCompleted && (
        <Button color='success' className='btn-label' onClick={onSaveCompleted}>
          <i className='ri-check-double-line label-icon align-middle'></i>
          Save &amp; Completed
        </Button>
      )}
      {showSubmit && (
        <Button color='primary' className='btn-label' onClick={onSubmit}>
          <i className='ri-send-plane-line label-icon align-middle'></i>
          Submit
        </Button>
      )}
    </div>
  );
};

export default FloatingActions;
